<template>
  <div class="col-12 ">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('grades.addNewTitle') }}
            </h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 mx-2">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <GradeSheetForm 
              ref="gradeSheetForm"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
            
            <div class="d-flex gap-3 mt-3">
              <button 
                type="button" 
                class="btn btn-primary btn-sm flex-grow-1"
                @click="submitForm"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin ms-2"></i>
                  {{ $t('grades.adding') }}
                </span>
                <span v-else>
                  <i class="fas fa-plus ms-2"></i>
                  {{ $t('grades.addButton') }}
                </span>
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times ms-2"></i>
                {{ $t('common.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import GradeSheetForm from '@/components/features/grade-sheets/GradeSheetForm.vue';
import { useToast } from 'vue-toastification';

import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const router = useRouter();
const store = useStore();
const toast = useToast();
const gradeSheetForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    await store.dispatch('gradeSheets/createGradeSheet', formData);
    toast.success(t('grades.addSuccess'));
    router.push('/grade-sheets');
  } catch (error) {
    if (error.response?.status === 422) {
      const errors = error.response.data.errors;
      gradeSheetForm.value?.setServerErrors(errors);
      for (const field in errors) {
        toast.error(errors[field][0]);
      }
    } else {
      toast.error(error.response?.data?.message || t('grades.addError'));
    }
  } finally {
    isSubmitting.value = false;
  }
};

const submitForm = () => {
  gradeSheetForm.value?.submit();
};

const handleValidationError = () => {
  toast.warning(t('grades.validationError'));
};

const handleCancel = () => {
  router.push('/grade-sheets');
};
</script>
